import styled from 'styled-components';

// Components
import { CaretDownFilled } from '@ant-design/icons';
import { Select, Typography } from 'top-component-library';

export const DropdownArrow = styled(CaretDownFilled)`
  align-items: center;
  color: white;
  display: flex;
  font-size: 0.875rem;
  margin-left: 0.5rem;
`;

export const NoData = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 2.875rem;
`;

export const NoDataText = styled(Typography.Text)`
  font-size: 0.875rem;
  text-transform: uppercase;
`;

export const Placeholder = styled.div`
  display: flex;
`;

export const LocationDropdownSelect = styled(Select)`
  && {
    .ant-select-selection-placeholder {
      align-items: center;
      color: white;
      display: flex;
      font-size: 0.875rem;
      font-weight: bold;
      justify-content: center;
      letter-spacing: 1px;
      text-align: center;
      text-transform: uppercase;
    }

    .ant-select-selector {
      background: var(--color-button-landing-page__regular);
      border-color: var(--color-button-landing-page__regular);
      border-radius: var(--input__border-radius);
      height: 2.875rem;

      &:hover {
        border-color: var(--color-button-landing-page__regular);
      }
    }
  }
`;
